const isUpcomingOrDraftInvoice = (invoice) => Boolean(
  !invoice
  || !invoice.id
  || invoice.status === 'draft'
  || (invoice.date && invoice.date * 1000 > Date.now()),
);

const isSubscriptionInvoice = (invoice) => (invoice?.lines?.data || []).some((line) => line?.type === 'subscription');

const isUnpaidInvoice = (invoice) => invoice?.paid === false && invoice?.status !== 'void' && invoice?.status !== 'paid';

const isExpiredCardDecline = (invoice) => {
  const chargeCode = invoice?.charge && typeof invoice.charge === 'object'
    ? invoice.charge.failure_code
    : null;
  const lastPaymentError = invoice?.payment_intent && typeof invoice.payment_intent === 'object'
    ? invoice.payment_intent.last_payment_error
    : null;
  const intentCode = lastPaymentError?.decline_code || lastPaymentError?.code;

  return chargeCode === 'expired_card' || intentCode === 'expired_card';
};

const isLatestSubscriptionPaymentFailedDueToExpiredCard = (invoices) => {
  if (!Array.isArray(invoices) || !invoices.length) {
    return false;
  }

  const latestSubscriptionInvoice = invoices
    .filter((invoice) => !isUpcomingOrDraftInvoice(invoice) && isSubscriptionInvoice(invoice))
    .sort((left, right) => (right.created || 0) - (left.created || 0))[0];

  return Boolean(
    latestSubscriptionInvoice
    && isUnpaidInvoice(latestSubscriptionInvoice)
    && isExpiredCardDecline(latestSubscriptionInvoice),
  );
};

export default isLatestSubscriptionPaymentFailedDueToExpiredCard;
